// extracted by mini-css-extract-plugin
module.exports = {"iconPlus":"UserLocations_iconPlus__2vl44","addButton":"UserLocations_addButton__3lGCG"};